<template>
  <v-card class="mb-4" v-if="placeDetail.name">
    <v-carousel
      :continuous="false"
      :cycle="true"
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="mdi-minus"
      height="300"
    >
      <v-carousel-item v-for="(item, i) in placeDetail.photos" :key="i">
        <v-img
          aspect-ratio="1"
          lazy-src="https://via.placeholder.com/200"
          :src="item.full_path"
          @error="imageErrorHandler"
        ></v-img>
      </v-carousel-item>
    </v-carousel>
    <v-card-text class="mt-0">
      <h1 class="mb-2">{{ placeDetail.name }}</h1>
      <p>
        {{ placeDetail.province }}, {{ placeDetail.municipality }},
        {{ placeDetail.district }}, {{ placeDetail.sub_district }},
        {{ placeDetail.street_address }}
      </p>
    </v-card-text>
    <v-btn color="error" depressed block small @click="close()">
      close
    </v-btn>
  </v-card>
</template>

<script>
import { EventBus } from "@/utils/eventBus";

export default {
  props: {
    placeDetail: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    imageErrorHandler() {},
    close() {
      EventBus.$emit("CLOSE_PLACE_DETAIL");
    }
  }
};
</script>

<style></style>
